import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../../factories/tab-page";
import baoRouter from "./../../services/bao-router";
function ProjectAssignmentViewModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(self, tabPage);
    self.ConfigurationItem = parent;
    self.Bao = Bao;
    self.GoToOwner = function () {
        baoRouter.setHash("#person/" + self.ConfigurationItem.OwnerId());
    };
    self.GoToCustomer = function (item) {
        baoRouter.setHash("#customer/" + self.ConfigurationItem.CustomerId());
    };
    self.SelectedAccountAssignment = ko.observable();
    self.SelectedAccountAssignment.subscribe(function (newValue) {
        if (newValue != null) {
            if (self.ConfigurationItem.AccountAssignmentTypeId() == null) {
                self.ConfigurationItem.AccountAssignmentTypeId(newValue.AccountAssignmentTypeId);
                self.ConfigurationItem.AccountAssignmentTypeName(newValue.AccountAssignmentTypeName);
            }
        }
    });
    self.SelectedOwner = ko.observable();
    self.SelectedOwner.subscribe(function (newValue) {
        if (newValue != null) {
            self.ConfigurationItem.Owner.FullName(newValue.FullName);
            self.ConfigurationItem.Owner.LocationName(newValue.LocationName);
            self.ConfigurationItem.Owner.AccountAssignmentTypeName(newValue.AccountAssignmentTypeName);
            self.ConfigurationItem.Owner.AccountAssignment(newValue.AccountAssignment);
            self.ConfigurationItem.Owner.DepartmentName(newValue.DepartmentName);
            self.ConfigurationItem.Owner.BuildingName(newValue.BuildingName);
            self.ConfigurationItem.Owner.Room(newValue.Room);
            self.ConfigurationItem.Owner.Telephone(newValue.Telephone);
        }
    });
    self.Refresh = function () {
        var def = $.Deferred();
        self.GetOwner().then(function () {
            if (self.ConfigurationItem.ParentConfigurationItemId() != null) {
                self.SetParent(self.ConfigurationItem.ParentConfigurationItemId()).then(def.resolve);
            }
            else {
                def.resolve();
            }
        });
        return def.promise();
    };
    self.GetOwner = function () {
        return Bao.post("ConfigurationItemTab/GetOwner", JSON.stringify({
            id: self.ConfigurationItem.OwnerId()
        }), function (value) {
            self.ConfigurationItem.TabPage.DirtyFlag.pause();
            ko.map.fromJS(value, self.ConfigurationItem.Owner);
            self.ConfigurationItem.TabPage.DirtyFlag.resume();
        });
    };
    self.ConfigurationItem.CustomerId.subscribe(function () {
        self.ConfigurationItem.LocationId(null);
        self.ConfigurationItem.LocationName("");
        self.ConfigurationItem.OwnerId(null);
        self.ConfigurationItem.Owner.FullName("");
        self.ConfigurationItem.Owner.LocationName("");
        self.ConfigurationItem.Owner.AccountAssignmentTypeName("");
        self.ConfigurationItem.Owner.AccountAssignment("");
        self.ConfigurationItem.Owner.DepartmentName("");
        self.ConfigurationItem.Owner.BuildingName("");
        self.ConfigurationItem.Owner.Room("");
        self.ConfigurationItem.Owner.Telephone("");
    });
    self.CompleteCheck = function () {
        if (self.ConfigurationItem.CustomerId() == null) {
            return false;
        }
        return true;
    };
    self.init = function () { };
    self.loaded = function () { };
}
;
Bao.inherit(ProjectAssignmentViewModel, ChildTabViewModel);
export default ProjectAssignmentViewModel;